const snippetMenuDesktopContainer = document.querySelector('.desktop-menu__container');

const firstLevels = [
  ...snippetMenuDesktopContainer.querySelectorAll('.desktop-menu__first-level-link'),
];
firstLevels.forEach((firstLevel) => {
  const wrapper = firstLevel.querySelector(':scope > span, :scope > a');
  const text = firstLevel.querySelector(
    ':scope > a > span, :scope > span > span',
  );
  const dropdown = firstLevel.querySelector('.desktop-menu__dropdown');
  if (!wrapper || !text) return;

  wrapper.addEventListener('mouseenter', () => {
    if (
      firstLevel.classList.contains('open') ||
      firstLevels.some((el) => el.classList.contains('open')) ||
      !dropdown
    )
      return;
    firstLevel.classList.add('open');
  });
  text.addEventListener('mouseenter', () => {
    if (firstLevel.classList.contains('open')) return;
    firstLevels.forEach((el) => el.classList.remove('open'));
    if (!dropdown) return;
    firstLevel.classList.add('open');
  });
});
snippetMenuDesktopContainer.addEventListener('mouseleave', () =>
  firstLevels.forEach((dropdown) => dropdown.classList.remove('open')),
);

snippetMenuDesktopContainer.querySelector('.desktop-menu__search > span').addEventListener('click', function() {
  const searchForm = snippetMenuDesktopContainer.querySelector('.desktop-menu__search form');
  if (searchForm) {
    searchForm.classList.toggle('hidden');
  }
});

